import { Helmet } from "react-helmet-async";
import Hero from "../components/Hero";
import SearchBar from "../components/SearchBar";
import PopularDestinations from "../components/PopularDestinations";
import TopRatedHotels from "../components/TopRatedHotels";
import HotelList from "../components/HotelList";
import WhyChooseUs from "../components/WhyChooseUs";
import BlogSection from "../components/BlogSection";
import Testimonials from "../components/Testimonials";
import TrustedPartners from "../components/TrustedPartners";
import CTASection from "../components/CTASection";

import heroImg from "../assests/images/slider-1.webp";
import heroImg2 from "../assests/images/slider-2.webp";
import heroImg3 from "../assests/images/slider-3.webp";
import heroImg4 from "../assests/images/slider-4.webp";
import heroImg5 from "../assests/images/slider-5.webp";
import heroImg6 from "../assests/images/slider-6.webp";

// import {
//   Building2,
//   BadgeDollarSign,
//   Users,
//   Headphones,
// } from "lucide-react";

export default function Home() {
  return (
    <div>

      <Helmet>
        <title>Jumeira Discount Hotels | Best Hotel Deals in Dubai</title>

        <meta
          name="description"
          content="Book cheap hotels, apartments, and resorts in Dubai. Compare prices and save up to 60% on your next stay with Jumeira Discount Hotels."
        />

        <link
          rel="canonical"
          href="https://jumeiradiscounthotels.com/"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Jumeira Discount Hotels | Best Hotel Deals in Dubai"
        />

        <meta
          property="og:description"
          content="Book cheap hotels, apartments, and resorts in Dubai. Compare prices and save up to 60% on your next stay with Jumeira Discount Hotels."
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:url"
          content="https://jumeiradiscounthotels.com/"
        />

        <meta
          property="og:image"
          content="https://jumeiradiscounthotels.com/images/default-og.png"
        />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="Jumeira Discount Hotels | Best Hotel Deals in Dubai"
        />

        <meta
          name="twitter:description"
          content="Book cheap hotels, apartments, and resorts in Dubai. Compare prices and save up to 60% on your next stay with Jumeira Discount Hotels."
        />

        <meta
          name="twitter:image"
          content="https://jumeiradiscounthotels.com/images/default-og.png"
        />

        {/* SEO */}
        <meta
          name="robots"
          content="index, follow"
        />
      </Helmet>

      {/* HERO */}
      <section className="relative">

        <Hero
          variant="home"
          title="Find the Best Hotel Deals in Dubai"
          subtitle="Save up to 60% on hotels, apartments and resorts across Dubai. Compare prices and book instantly."
          backgroundImages={[
            heroImg,
            heroImg2,
            heroImg3,
            heroImg4,
            heroImg5,
            heroImg6,
          ]}
          slideInterval={5000}
        >
          <SearchBar />
        </Hero>

      </section>

      {/* Statistics */}
      {/* <section className="relative mt-0 pt-8 sm:pt-10 lg:-mt-12 lg:pt-0 z-10 pb-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">

            <div className="group bg-white rounded-2xl lg:rounded-3xl p-4 sm:p-5 lg:p-6 text-center shadow-lg border border-orange-100 hover:-translate-y-2 hover:shadow-xl transition-all duration-300">
              <div className="w-12 h-12 sm:w-14 sm:h-14 mx-auto mb-3 sm:mb-4 rounded-2xl bg-orange-100 flex items-center justify-center">
                <Building2 className="w-6 h-6 sm:w-7 sm:h-7 text-[#0F172A]" />
              </div>
              <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0F172A]">
                500+
              </h3>
              <p className="mt-1 sm:mt-2 text-sm sm:text-base text-slate-600 font-medium">
                Hotels Available
              </p>
            </div>

            <div className="group bg-white rounded-2xl lg:rounded-3xl p-4 sm:p-5 lg:p-6 text-center shadow-lg border border-orange-100 hover:-translate-y-2 hover:shadow-xl transition-all duration-300">
              <div className="w-12 h-12 sm:w-14 sm:h-14 mx-auto mb-3 sm:mb-4 rounded-2xl bg-orange-100 flex items-center justify-center">
                <BadgeDollarSign className="w-6 h-6 sm:w-7 sm:h-7 text-[#0F172A]" />
              </div>
              <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0F172A]">
                Lowest
              </h3>
              <p className="mt-1 sm:mt-2 text-sm sm:text-base text-slate-600 font-medium">
                Price Guarantee
              </p>
            </div>

            <div className="group bg-white rounded-2xl lg:rounded-3xl p-4 sm:p-5 lg:p-6 text-center shadow-lg border border-orange-100 hover:-translate-y-2 hover:shadow-xl transition-all duration-300">
              <div className="w-12 h-12 sm:w-14 sm:h-14 mx-auto mb-3 sm:mb-4 rounded-2xl bg-orange-100 flex items-center justify-center">
                <Users className="w-6 h-6 sm:w-7 sm:h-7 text-[#0F172A]" />
              </div>
              <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0F172A]">
                10K+
              </h3>
              <p className="mt-1 sm:mt-2 text-sm sm:text-base text-slate-600 font-medium">
                Happy Guests
              </p>
            </div>

            <div className="group bg-white rounded-2xl lg:rounded-3xl p-4 sm:p-5 lg:p-6 text-center shadow-lg border border-orange-100 hover:-translate-y-2 hover:shadow-xl transition-all duration-300">
              <div className="w-12 h-12 sm:w-14 sm:h-14 mx-auto mb-3 sm:mb-4 rounded-2xl bg-orange-100 flex items-center justify-center">
                <Headphones className="w-6 h-6 sm:w-7 sm:h-7 text-[#0F172A]" />
              </div>
              <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0F172A]">
                24/7
              </h3>
              <p className="mt-1 sm:mt-2 text-sm sm:text-base text-slate-600 font-medium">
                Customer Support
              </p>
            </div>

          </div>
        </div>
      </section> */}

      {/* SECTIONS */}
      <TopRatedHotels limit={3} />
      <PopularDestinations limit={6} showViewAllButton={true} />


      <HotelList
        showSidebar={false}
        limit={3}
        showViewAllButton={true}
        showBanner={false}
        showHeading={true}
      />
      <WhyChooseUs />
      <BlogSection />
      <Testimonials />
      <TrustedPartners />
      <CTASection />

    </div>
  );
}